import { render } from "./Simple.vue?vue&type=template&id=a4a373f0&ts=true"
import script from "./Simple.vue?vue&type=script&lang=ts"
export * from "./Simple.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agnisvegners/projects/anatomynext/a4s-admin-hpc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__